import '../utils/responsiveHelper';
import '../utils/tabs';

const initProductTabs = () => {
  const tab = jQuery('.description-tabs');
  const activeClass = 'active';
  let bool = false;
  const links = jQuery('.single_smooth_link');
  const speed = 300;

  window.ResponsiveHelper.addRange({
    '768..': {
      on: () => {
        tab.tabset({
          tabLinks: 'a',
          event: 'click',
          defaultTab: true,
          onChange(self) {
            const href = self.$tabLinks.eq(self.activeTabIndex).attr('href').split('#')[1];
            const target = jQuery(`[data-tab="${href}"]`);
            const allItems = target.parent().children();

            allItems.removeClass(activeClass);
            target.addClass(activeClass);
          },
        });
        bool = true;
      },
      off: () => {
        tab.tabset('destroy');
        bool = false;
      },
    },
  });

  if (links.length) {
    links.on('click', function clickHandler(e) {
      e.preventDefault();
      const $this = jQuery(this);

      if (bool) {
        tab.find(`[href="${$this.attr('href')}"]`).trigger('click');
      }

      setTimeout(() => {
        const top = bool ? tab.offset().top : jQuery($this.attr('href')).offset().top;
        jQuery('html, body').animate(
          {
            scrollTop: top - jQuery('.header').outerHeight(),
          },
          speed
        );
      }, 10);
    });
  }
};

export default initProductTabs;
